import { produce } from 'immer'
import { State } from '../typings'
import { ServiceLocation } from '@user/store/entityLocations'

export type ApplySelectionAction = {
  type: 'applySelection'
  payload: {
    location?: ServiceLocation
    redirect: boolean
  }
}

type ApplySelectionActionCreator = (
  location?: ServiceLocation,
  redirect?: boolean,
) => ApplySelectionAction

export const applySelection = produce<State, [ApplySelectionAction['payload']]>(
  (draft, payload) => {
    const { redirect, location } = payload

    if (!!location) {
      draft.selectedServiceLocations.set(location.id, location)
    }

    if (
      !!draft.primaryServiceLocation &&
      draft.selectedServiceLocations.size > 0
    ) {
      draft.appliedSelections = {
        billTo: draft.primaryServiceLocation.billTo,
        serviceLocations: [...draft.selectedServiceLocations.values()],
      }
    }

    draft.shouldRedirect = redirect
  },
)

export const applySelectionActionCreator: ApplySelectionActionCreator = (
  location,
  redirect = false,
) => ({
  type: 'applySelection',
  payload: { location, redirect },
})
